module.exports = __webpack_public_path__ + "img/flynn-logo-white.c9726673.png";